import { render, staticRenderFns } from "./POView.vue?vue&type=template&id=3924f8f1&"
import script from "./POView.vue?vue&type=script&lang=js&"
export * from "./POView.vue?vue&type=script&lang=js&"
import style0 from "./POView.vue?vue&type=style&index=0&id=3924f8f1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports